import { selectTextInputsOnFocus } from './select-text-inputs-on-focus';

function selectAndSetAttribute(
  node: Element,
  selector: string,
  checkClass: string,
  attribute: string,
  value: string,
): void {
  (node.querySelectorAll(selector) as NodeListOf<HTMLInputElement>).forEach(input => {
    if (!input.classList.contains(checkClass)) {
      input.setAttribute(attribute, value);
    }
  });
}

/**
 * Disables the interference of certain password filler applications (e.g., LastPass, 1Password, Bitwarden) and browser autocomplete
 * by modifying specific attributes of input fields dynamically added to the DOM.
 * This function observes changes in the DOM and applies the necessary attributes to input fields to ensure they are ignored
 * by password filler tools, while setting attributes for browser autocomplete compatibility and enabling text auto-selection on focus.
 *
 * @return {void} This function does not return any value.
 */
export function disableAutofillOnFieldsAndSetAutoselectText(): void {
  const mutationObserver = new MutationObserver((mutations: MutationRecord[]) => {
    mutations.forEach(mutation => {
      Array.from(mutation.addedNodes).forEach((node: any) => {
        if (
          node !== null &&
          typeof node.querySelector === 'function' &&
          node.querySelector('input') !== null
        ) {
          selectAndSetAttribute(
            node,
            'input:not([data-with-last-pass])',
            'data-with-last-pass',
            'data-lpignore',
            'true',
          );
          selectAndSetAttribute(
            node,
            'input:not([data-with-1password])',
            'data-with-1password',
            'data-1p-ignore',
            'true',
          );
          selectAndSetAttribute(
            node,
            'input:not([data-with-bitwarden])',
            'data-with-bitwarden',
            'data-bwignore',
            'true',
          );
          selectAndSetAttribute(
            node,
            'input:not([data-with-browser-autocomplete])',
            'data-with-browser-autocomplete',
            'autocomplete',
            'on',
          );

          // set auto select text when focus element
          selectTextInputsOnFocus(node);
        }
      });
    });
  });
  mutationObserver.observe(document.documentElement, {
    attributes: false,
    childList: true,
    characterData: false,
    subtree: true,
  });
}
